module.exports = __webpack_public_path__ + "static/media/icon-docker.7fa48688.svg";